import { useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchEtablissementById } from "../../store/slices/etablissementSlice";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GoogleLoginButton from "../../components/googleBtn";
import Divider from "../../components/divider";
import { ErrorMessage, Field, Form, Formik } from "formik"; // Import Form from formik
import { GoogleOAuthProvider } from "@react-oauth/google";
import * as Yup from "yup";
import Layout from "../reservation/layout";
import { createRendezvous } from "../../store/slices/rendezVousSlice";

const IdentificationInvite = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();
  const { id } = useParams();
  const { loading, error } = useSelector((state) => state.user);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Email invalide").required("L'email est requis"),
    nom: Yup.string().required("Le nom est requis"),
    prenom: Yup.string().required("Le prénom est requis"),
  });

  const etablissement = useSelector(
    (state) => state.etablissements.selectedEtablissement
  );
  const prestations = useSelector(
    (state) => state.rendezvous.selectedPrestations
  );

  useEffect(() => {
    dispatch(fetchEtablissementById(id));
  }, [dispatch, id]);

  const handleSubmit = async (values) => {
    // console.log(values);
    const appointment = {
      ...data,
      guest_email: values?.email,
      guest_nom: values?.nom,
      guest_prenom: values?.prenom,
    };
    // console.log({ appointment });
    // Handle form submission here
    try {
      // Dispatch the create appointment action
      const resultAction = await dispatch(createRendezvous(appointment));

      if (createRendezvous.fulfilled.match(resultAction)) {
        // Success case
        localStorage.setItem(
          "resultAction",
          JSON.stringify(resultAction?.payload?.appointment)
        );
        navigate(`/facturation/${id}`);
      } else {
        // Handle error case
        // console.error("Failed to create appointment:", resultAction.payload);
        // alert("Erreur lors de la création du rendez-vous");
      }
    } catch (error) {
      // console.error("Error creating appointment:", error);
      // alert("Une erreur est survenue");
    }
  };

  return (
    <Layout
      currentStep={2}
      etablissement={etablissement}
      prestation={prestations.filter((p) => p.selected)}
      recap={false}
      identification={true}
    >
      <div className="mb-24 mx-auto">
        <Formik
          initialValues={{
            email: "",
            nom: "",
            prenom: "",
            rememberMe: false,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, isSubmitting }) => (
            <div className="p-24 bg-white">
              <h3 className="grey500 text-center">Mes informations</h3>

              <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
              >
                {/* Use Formik's Form component instead of react-router-dom's */}
                <Form className="login-form w-100 mt-24">
                  {/* Email Field */}
                  <div className="input-wrapper">
                    <label className="form-label">Email*</label>
                    <Field
                      name="email"
                      type="email"
                      className={
                        touched.email && errors.email ? "is-invalid" : ""
                      }
                      placeholder="john@gmail.com"
                    />
                    <ErrorMessage name="email">
                      {(msg) => (
                        <div className="error-message mt-1">
                          <img
                            src="/images/alert-circle.svg"
                            className="arrow mr-8"
                            alt="Error"
                          />
                          {msg}
                        </div>
                      )}
                    </ErrorMessage>
                  </div>

                  {/* Nom and Prenom Fields */}
                  <div className="row mt-24">
                    <div className="input-wrapper col-md-6">
                      <label className="form-label">Nom*</label>
                      <Field
                        name="nom"
                        type="text"
                        className={
                          touched.nom && errors.nom ? "is-invalid" : ""
                        }
                        placeholder="Dupont"
                      />
                      <ErrorMessage name="nom">
                        {(msg) => (
                          <div className="error-message mt-1">
                            <img
                              src="/images/alert-circle.svg"
                              className="arrow mr-8"
                              alt="Error"
                            />
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>

                    <div className="input-wrapper col-md-6">
                      <label className="form-label">Prénom*</label>
                      <Field
                        name="prenom"
                        type="text"
                        className={
                          touched.prenom && errors.prenom ? "is-invalid" : ""
                        }
                        placeholder="Jean"
                      />
                      <ErrorMessage name="prenom">
                        {(msg) => (
                          <div className="error-message mt-1">
                            <img
                              src="/images/alert-circle.svg"
                              className="arrow mr-8"
                              alt="Error"
                            />
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="twyny-cta-primary w-100 mt-24"
                    disabled={isSubmitting || loading}
                  >
                    {isSubmitting || loading
                      ? "Connexion..."
                      : "Continuer en tant qu'invité"}
                  </button>

                  <Divider />
                </Form>

                <div>
                  <button
                    type="button"
                    onClick={() => navigate(`/identification/${id}`)}
                    className="twyny-cta-secondary w-100"
                  >
                    Se connecter
                  </button>
                  <button
                    type="button"
                    onClick={() => navigate(`/register-rdv/${id}`)}
                    className="twyny-cta-secondary w-100 mt-24"
                  >
                    Créer un compte
                  </button>
                  <div className="mt-24"></div>
                </div>

                <GoogleLoginButton />
              </GoogleOAuthProvider>
            </div>
          )}
        </Formik>
      </div>
    </Layout>
  );
};

export default IdentificationInvite;
